import Notifications from '@/fixtures/notifications'
import apiService from '@/services/apiService'

const User = {
  login (email, password) {
    // console.log(email, password)
    return new Promise((resolve, reject) => {
      apiService.post('api/login', {
        username: email,
        password: password
      }).then(result => {
        if (!result.data || !result.data.user || !result.data.user.roles) {
          reject(new Error('Result format not supported'))
        }
        const {roles} = result.data.user;
        if (roles.indexOf('ROLE_ADMIN') === -1 && roles.indexOf('ROLE_SUPER_ADMIN') === -1) {
          reject(new Error('You are not admin.'))
        }
        resolve(result.data)
        // apiService.setToken(result.data.refresh_token, result.data.token)
        // this.getUser().then((user) => {
        //   result.data.user.token = result.data.token
        //   result.data.user.refresh = result.data.refresh
        //   result.data.user.firstname = user.data.user.first_name
        //   result.data.user.firstname = user.data.user.first_name
        //   result.data.user.lastname = user.data.user.last_name
        //   result.data.user.id = user.data.user.id
        //   if (user.data.user.media) {
        //     result.data.user.picture = user.data.user.media.file
        //   }
        //   result.data.user.address = {
        //     line: user.data.user.address,
        //     zip: user.data.user.zipcode,
        //     city: user.data.user.city,
        //     country: user.data.user.country
        //   }
        //   result.data.user.phone = user.data.user.phone
        //   resolve(result.data)
        // }).catch((error) => {
        //   reject(error)
        // })
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getUser () {
    return new Promise((resolve, reject) => {
      apiService.get('api/profile').then((result) => {
        resolve(result.data.user)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  logout () {
    return new Promise((resolve, reject) => {
      apiService.get('api/logout').then((result) => {
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
  resetPassword (email) {
    return new Promise((resolve, reject) => {
      apiService.post('api/resetting/request', {
				email: email
			}).then(() => {
        resolve(true)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getNotifications (id) {
    return new Promise((resolve, reject) => {
      if (id === 1) {
        window.setTimeout(() => { resolve(Notifications) }, 1000)
      } else {
        window.setTimeout(() => { reject() }, 1000)
      }
    })
  },
  updateProfile (data) {
    const request = new FormData()
    request.append('first_name', data.firstname)
    request.append('last_name', data.lastname)
    request.append('email', data.email)
    // request.append('current_password', data.password)
    request.append('address', data.address.line)
    request.append('zipcode', data.address.zip)
    request.append('city', data.address.city)
    request.append('country', data.address.country)
    request.append('phone', data.phone)
    return apiService.post('api/profile', request)
  },
  editPassword (data) {
    return apiService.post('api/change-password', data)
  },
  enableUser (id) {
  return new Promise((resolve, reject) => {
          apiService.post('api/enable-user/' + id)
          .then(result => {
              resolve(result)
          })
          .catch(error => reject(error))
      })
  },
  disableUser (id) {
  return new Promise((resolve, reject) => {
          apiService.post('api/disable-user/' + id)
          .then(result => {
              resolve(result)
          })
          .catch(error => reject(error))
      })
  }
}

export default User



// WEBPACK FOOTER //
// ./src/services/api/user.js